/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer } from "../../shared";
import { CalendarHierarchyControl } from "./controls/CalendarHierarchyControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useDescription } from "./hooks/useDescription";
import { SLIDE_NUMBER } from "./constants";

export default function Slide13(props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const title = useSlideTitle();
  const subtitle = "";
  const description = useDescription();

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <CalendarHierarchyControl />
          <CommoditiesControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
          <ReportRenderer componentId="tables" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
